export default "__VITE_ASSET__KNhcjBx8__"